import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=c7638f30&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.css?vue&type=style&index=0&id=c7638f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7638f30",
  null
  
)

export default component.exports